/* steadi-cart-bridge.js — theme-side adapter for the Steadi picker.
   =================================================================
   The picker (assets/steadi-buy.js) is byte-identical to the file that ships on
   121 doors and MUST NOT be edited. On a door it owns its own Storefront cart
   and its own drawer. On steadilabs.com that produced TWO carts — measured
   2026-09-07: after adding through the picker, /cart.js still reported
   item_count 0 and the header still read "Cart".

   The picker's own delegation hook solves this: where the mount declares
   cart:"steadicart" it builds the line and hands it to window.SteadiCart, which
   then owns everything downstream. That is a documented extension point, not a
   change to the picker.

   THE PART THAT IS EASY TO GET WRONG — cart events.
   Dawn's product-form does not merely POST /cart/add.js; it then publishes
   PUB_SUB_EVENTS.cartUpdate ('cart-update'). Every subscriber hangs off that:
   the cart count, the drawer, apps, performance marks. A bridge that only
   fetches is invisible to all of them.

   It also matters for the acquisition spine (snippets/steadi-spine.liquid),
   which carries the first-party claim for orders completed on this storefront.
   The spine wants to re-stamp whenever the cart changes, because — its words —
   "Shopify can issue a new cart token, which would otherwise drop the
   attributes silently". It listens on three channels:
       document 'cart:updated', document 'cart:refresh',
       and window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, ...)
   Verified on the storefront 2026-09-07: window.PUB_SUB_EVENTS is UNDEFINED at
   that scope, so the third never registers, and nothing anywhere in the theme
   dispatches the first two. The spine's re-stamp has never actually run here.
   This bridge fires all of them, so the spine now re-stamps on every add.

   Attributes are '_'-prefixed to match the spine's convention: Shopify keeps
   them on the order and hides them from the shopper at checkout. Attribution
   itself is left to the spine — duplicating utm keys here would fight it. */
(function () {
  "use strict";

  var CART_UPDATE = "cart-update";   /* PUB_SUB_EVENTS.cartUpdate, constants.js */
  var CART_ERROR  = "cart-error";    /* PUB_SUB_EVENTS.cartError */

  function numericId(gid) { return String(gid == null ? "" : gid).split("/").pop(); }
  function drawer() { return document.querySelector("cart-drawer"); }

  function sectionsToRender() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === "function") {
      try { return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    }
    return ["cart-drawer", "cart-icon-bubble"];
  }

  /* Marks the order as having come through this picker rather than the section
     it replaced. Underscored so the shopper never sees it. */
  function stampAttributes() {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: { _picker: "v2" } })
    }).catch(function () { /* instrumentation must never cost a sale */ });
  }

  /* Fire every channel a subscriber might be on. Each is independently guarded:
     one throwing subscriber must not stop the others, or the sale. */
  function announce(variantId, cartData) {
    try {
      if (typeof window.publish === "function") {
        var name = (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || CART_UPDATE;
        window.publish(name, { source: "steadi-picker", productVariantId: variantId, cartData: cartData });
      }
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cartData: cartData } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cartData: cartData } })); } catch (e) {}
  }

  function announceError(variantId, payload) {
    try {
      if (typeof window.publish === "function") {
        var name = (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartError) || CART_ERROR;
        window.publish(name, {
          source: "steadi-picker", productVariantId: variantId,
          errors: (payload && (payload.errors || payload.description)) || null,
          message: payload && payload.message
        });
      }
    } catch (e) {}
  }

  window.SteadiCart = {
    addToCart: function (line) {
      var variantId = numericId(line.variantId);
      var properties = {};
      (line.attributes || []).forEach(function (a) {
        if (a && a.key) properties[a.key] = a.value;
      });
      var body = {
        items: [{ id: variantId, quantity: 1, properties: properties }],
        sections: sectionsToRender(),
        sections_url: window.location.pathname
      };
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              announceError(variantId, data);
              throw new Error((data && (data.description || data.message)) || "Could not add that — try again.");
            }
            return data;
          });
        })
        .then(function (data) {
          /* Stamp BEFORE announcing, so a spine re-stamp triggered by the
             announcement sees the cart in its final state. */
          return stampAttributes().then(function () { return data; });
        })
        .then(function (data) {
          var d = drawer();
          if (d) {
            try {
              if (d.classList) d.classList.remove("is-empty");
              if (typeof d.renderContents === "function") d.renderContents(data);
              else if (typeof d.open === "function") d.open();
            } catch (e) {}
          } else {
            fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
              var b = document.querySelector("#cart-icon-bubble .cart-count-bubble span");
              if (b) b.textContent = c.item_count;
            }).catch(function () {});
          }
          announce(variantId, data);
          return data;
        });
    }
  };
})();
